import { GlobalAppState } from '@state/store';

export const getHistory = (state: GlobalAppState) => state.app.history;
export const getHistoryLength = (state: GlobalAppState) => state.app.history.length;
